import { render, staticRenderFns } from "./MatchResultsTeam.vue?vue&type=template&id=3d4d2733&"
import script from "./MatchResultsTeam.vue?vue&type=script&lang=js&"
export * from "./MatchResultsTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports